import React from 'react'

// Original vectors from Figma frame 220, Group 6528. The view box is the number card's 52px icon slot
// at the frame position, so the artwork keeps its designed offset; the badge stroke runs 2px past it.
const NotOnTrackStreakIcon = () => (
  <svg
    width={52}
    height={54}
    viewBox="120 788 52 54"
    fill="none"
    overflow="visible"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M123.82 817.37C124.081 815.65 125.165 814.166 126.725 813.395L136.084 808.768L141.276 812.894L146.468 808.768L155.827 813.395C157.386 814.166 158.471 815.65 158.732 817.37L159.323 821.275C159.494 822.399 158.623 823.411 157.486 823.411H125.066C123.929 823.411 123.058 822.399 123.229 821.275L123.82 817.37Z"
      fill="#CDDBF6"
    />
    <rect x="133.555" y="788" width="15.4424" height="19.4361" rx="7.72118" fill="#CDDBF6" />
    <path
      d="M172.64 822.979C172.64 829.921 167.012 835.549 160.069 835.549C153.127 835.549 147.499 829.921 147.499 822.979C147.499 816.036 153.127 810.408 160.069 810.408C167.012 810.408 172.64 816.036 172.64 822.979Z"
      fill="#8FB4FF"
      stroke="white"
      strokeWidth="3.27922"
    />
    <path d="M160.069 816.022V823.972" stroke="white" strokeWidth="3.97481" />
    <path d="M160.069 825.96V829.935" stroke="white" strokeWidth="3.97481" />
  </svg>
)

export default NotOnTrackStreakIcon
